// This is a feature model similar to app.module

import { NgModule } from '@angular/core';


@NgModule({
	providers: [],
})
export class ModelModule {}
